import React from 'react';

export const WarningIncon = () => (
  <svg
    style={{ overflow: 'inherit' }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2276_45520)">
      <path
        d="M15.6677 11.9986L10.0157 1.60877C9.10762 0.0799923 6.89396 0.0779611 5.98465 1.60877L0.332898 11.9986C-0.595414 13.5608 0.528492 15.539 2.34796 15.539H13.6522C15.4701 15.539 16.5961 13.5624 15.6677 11.9986ZM8.00018 13.664C7.48337 13.664 7.06268 13.2433 7.06268 12.7265C7.06268 12.2097 7.48337 11.789 8.00018 11.789C8.51699 11.789 8.93768 12.2097 8.93768 12.7265C8.93768 13.2433 8.51699 13.664 8.00018 13.664ZM8.93768 9.91399C8.93768 10.4308 8.51699 10.8515 8.00018 10.8515C7.48337 10.8515 7.06268 10.4308 7.06268 9.91399V5.22649C7.06268 4.70968 7.48337 4.28899 8.00018 4.28899C8.51699 4.28899 8.93768 4.70968 8.93768 5.22649V9.91399Z"
        fill="var(--color-warning)"
      />
    </g>
    <defs>
      <clipPath id="clip0_2276_45520">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
